/**
 * URL for the main Dwello site — configurable via env var (set at build
 * time, like REACT_APP_API_URL) so a domain change or a staging
 * environment doesn't require editing source, matching the
 * REACT_APP_MANAGE_URL pattern already used in client/'s dashboardRoutes.ts.
 */
export const MAIN_SITE_URL = process.env.REACT_APP_MAIN_SITE_URL || 'https://www.dwello.ikxano.com';
